import { RefreshCw } from "lucide-react";

// ---------------------------------------------------------------------------
// ChunkReloadHint — Hinweis nach Deploy (POL-1).
// ---------------------------------------------------------------------------
// Wird gezeigt, wenn ein lazy-Baustein nach einem neuen Deploy nicht mehr
// geladen werden konnte. Der kontrollierte Auto-Reload greift meist sofort;
// dieser Hinweis ist die sichtbare Erholung, wenn der Schleifen-Guard einen
// weiteren Auto-Reload blockt (z.B. echtes Netzproblem). Kein Fehler-Look —
// es ist ein Update, kein Absturz.

export function ChunkReloadHint({
  fullscreen = false,
}: {
  fullscreen?: boolean;
}) {
  return (
    <div
      data-testid="chunk-reload-hint"
      className={`flex w-full items-center justify-center p-8 ${
        fullscreen ? "min-h-screen bg-background" : "min-h-full"
      }`}
    >
      <div className="w-full max-w-md rounded-md border border-border bg-card p-6 text-center">
        <div className="mx-auto mb-4 flex size-10 items-center justify-center rounded-full bg-surface-2">
          <RefreshCw className="size-5 text-foreground" />
        </div>
        <h1 className="text-base font-semibold text-foreground">
          Neue Version verfügbar
        </h1>
        <p className="mt-1 text-xs text-muted-foreground">
          Diese Seite wurde in der Zwischenzeit aktualisiert. Bitte neu laden,
          um weiterzuarbeiten.
        </p>
        <button
          type="button"
          data-testid="chunk-reload-button"
          onClick={() => window.location.reload()}
          className="mt-4 inline-flex items-center gap-2 rounded-md bg-primary px-4 py-2 text-sm font-medium text-primary-foreground shadow hover:bg-primary/90"
        >
          <RefreshCw className="size-3.5" />
          Neu laden
        </button>
      </div>
    </div>
  );
}
